module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    attrs: {
      "id": "wrapper"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c8f8a5d4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/pay/UnionPay.vue
// module id = 874
// module chunks = 0